/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

/**
 * Moves an item to a given position within the array
 *
 * @param {Array} array The array to convert.
 * @param {number} fromIndex The position in which the item is
 * @param {number} toIndex The position in which the item will move
 * @return {Array} The array with the new items ordering
 * @example
 */
export const moveArray = (array, fromIndex, toIndex) => {
  const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;

  if (startIndex >= 0 && startIndex < array.length) {
    const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;

    const [item] = array.splice(fromIndex, 1);
    array.splice(endIndex, 0, item);
  }
};

/**
 * Clones the given array and moves an item to a new position. Returns a new array, the given array is not mutated.
 *
 * @param {Array} array The array to convert.
 * @param {number} fromIndex The position in which the item is
 * @param {number} toIndex The position in which the item will move
 * @return {Array} A new array with the new items ordering
 * @example
 */
export const moveArrayImmutable = (array, fromIndex, toIndex) => {
  const newArray = [...array];
  moveArray(newArray, fromIndex, toIndex);
  return newArray;
};
